import { Link } from 'react-router-dom';

function Feed(props) {
  const baseUrl = props.docType === 'Purchase' ? '/purchase-order' : '/transfer-order';
  return (
    <Link to={`${baseUrl}/${props.VendorType}/${props.docNo}`} target="_blank">
      <div className="row m-b-10 align-items-center feed">
        <div className="col-auto p-r-0">
          {props.docType === 'Purchase' ? (
            <i className="feather icon-shopping-cart badge-info feed-icon"></i>
          ) : props.docType === 'Transfer' ? (
            <i className="feather icon-corner-down-left badge-success feed-icon"></i>
          ) : (
            <i className="feather icon-bell badge-danger feed-icon"></i>
          )}
        </div>
        <div className="col">
          <h6 className="m-b-5">
            {props.docType === 'Purchase'
              ? ' New order received '
              : props.docType === 'Transfer'
              ? ' New order transferred '
              : 'Feedback required for '}
            <b>{props.docNo}</b>
          </h6>
        </div>
      </div>
    </Link>
  );
}

export default Feed;
